import { render, staticRenderFns } from "./Grids.vue?vue&type=template&id=3d054986&scoped=true&"
var script = {}
import style0 from "./Grids.vue?vue&type=style&index=0&id=3d054986&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d054986",
  null
  
)

export default component.exports